document.addEventListener('DOMContentLoaded', function () {
    // Initialize tabs for each section
    const tabSections = document.querySelectorAll('.tab-section');

    tabSections.forEach(function (section) {
        const tabButtons = section.querySelectorAll('.tab-nav-button');
        const tabContents = section.querySelectorAll('.tab-content');

        tabButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                const targetId = this.getAttribute('data-tab-target');
                const targetContent = section.querySelector('#' + targetId);

                // Remove active class from all buttons and contents
                tabButtons.forEach(function (btn) {
                    btn.classList.remove('tab-nav-button--active');
                    btn.setAttribute('aria-selected', 'false');
                });

                tabContents.forEach(function (content) {
                    content.classList.remove('tab-content--active');
                    content.setAttribute('aria-hidden', 'true');
                });

                // Add active class to clicked button and corresponding content
                this.classList.add('tab-nav-button--active');
                this.setAttribute('aria-selected', 'true');

                if (targetContent) {
                    targetContent.classList.add('tab-content--active');
                    targetContent.setAttribute('aria-hidden', 'false');
                }
            });
        });
    });
});
